import { FieldModel } from '@cibo/core'
import { Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { FieldColumnProps } from './types'

export const fieldFarmColumn = ({ t, ...columnProps }: FieldColumnProps) => ({
  field: 'farm',
  headerName: t('farm', { ns: '@cibo/landmanager' }),
  flex: 1,
  minWidth: 150,
  // API doesn't support sorting at present
  sortable: false,
  renderCell: ({ row }: GridRenderCellParams<FieldModel>) => (
    //  @ts-ignore I don't know what this ts error is talking about
    <Typography data-testid="farm-cell">{row.farm?.item.name || null}</Typography>
  ),
  ...columnProps,
})
